import * as React from 'react';
import type { DashboardData } from '../features/dashboard/types/dashboard';

export type AppShellData = {
  client: DashboardData['client'];
  agency: DashboardData['agency'];
  agent: DashboardData['agent'];
  certificateSummary: {
    activeCount: number;
    pendingCount: number;
    totalIssuedLabel: string;
    expiringSoonCount: number;
  };
  linkedPolicies: DashboardData['linkedPolicies'];
  additionalInterests: DashboardData['additionalInterests'];
};

const defaultDashboardData: DashboardData = {
  client: {
    id: '',
    name: '',
    typeLabel: '',
    primaryContactName: '',
    addressLine1: '',
    addressLine2: '',
    phone: '',
    email: ''
  },
  certificates: [],
  requests: [],
  linkedPolicies: [],
  additionalInterests: [],
  activity: [],
  agency: {
    id: '',
    name: '',
    typeLabel: ''
  },
  agent: {
    id: '',
    name: '',
    licenseNumber: '',
    phone: '',
    email: ''
  }
};

export default function useAppShellData(): AppShellData {
  const [data] = React.useState<DashboardData>(defaultDashboardData);

  const activeCount = data.certificates.filter((c) => c.status === 'Active').length;
  const pendingCount = data.certificates.filter((c) => c.status === 'Pending').length;

  return {
    client: data.client,
    agency: data.agency,
    agent: data.agent,
    certificateSummary: {
      activeCount,
      pendingCount,
      totalIssuedLabel: '155',
      expiringSoonCount: 2
    },
    linkedPolicies: data.linkedPolicies,
    additionalInterests: data.additionalInterests
  };
}
